import { SUPPORT_ESCALATED, ADMINS } from "../../config/roleConfig";

export function isSupportEscalated(role, subrole) {
  try {
    return ADMINS.includes(role) && SUPPORT_ESCALATED.includes(subrole);
  } catch (e) {
    return false;
  }
}
